<template>
  <v-autocomplete
    data-lpignore="true"
    v-bind:item-text="itemText"
    v-bind:item-value="itemValue"
    v-bind:items="items"
    v-bind:label="label"
    v-bind:disabled="disabled"
    v-bind:search-input.sync="searchInput"
    v-on:input="emitInput"
    v-bind:value="value"
    attach=""
    chips
    multiple
    hide-details="auto"
    v-on="$listeners">
    <template v-slot:prepend-item>
      <v-list-item
        v-if="setSelectAllOption"
        ripple
        v-on:mousedown.prevent
        v-on:click="onSelectAllClick"
      >
        <v-list-item-action>
          <v-icon :color="value.length > 0 || selectAllValue ? 'indigo darken-4' : ''">
            {{ selectAllOptionIcon }}
          </v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title>
            {{ selectAllText }}
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-divider class="mt-2" />
      <slot name="prepend-item" />
    </template>
    <template v-slot:no-data>
      <slot name="no-data">
        <p class="no-data">Результатов нет</p>
      </slot>
    </template>
    <template v-slot:selection="{ item, index }">
      <v-chip
        v-if="index < 3"
        v-bind:close="removalPerChip"
        v-on:click:close="onChipRemove(item)"
      >
        <span>{{ item[itemText] }}</span>
      </v-chip>
      <span
        v-else-if="index === 3"
        class="grey--text text-caption"
      >(+{{ value.length - 3 }})</span>
    </template>
  </v-autocomplete>
</template>

<script>
export default {
  computed: {
    /**
     * @description Выбраны все элементы
     * @return {boolean}
     */
    isSelectedAllItems() {
      return this.value.length === this.items.length || this.selectAllValue;
    },
    /**
     * @description Выбраны некоторые элементы
     * @return {boolean}
     */
    isSelectedSomeItems() {
      return this.value.length > 0 && !this.isSelectedAllItems;
    },
    /**
     * @description Иконка элемента "выбрать все"
     * @return {string}
     */
    selectAllOptionIcon() {
      if (this.isSelectedAllItems) {
        return 'mdi-close-box';
      }
      if (this.isSelectedSomeItems) {
        return 'mdi-minus-box';
      }
      return 'mdi-checkbox-blank-outline';
    },
  },
  data() {
    return {
      searchInput: '',
    };
  },
  name: 'MultipleAutocompleteInput',
  methods: {
    /**
     * @description Обработать удаление по чипу.
     * @param {object} removalItem Удаляемый элемент.
     * @returns {void}
     */
    onChipRemove(removalItem) {
      const removedValue = removalItem[this.itemValue];
      const isNotRemoved = (value) => value !== removedValue;
      this.emitInput(this.value.filter(isNotRemoved));
    },
    /**
     * @description Клик на "выбрать все"
     */
    onSelectAllClick() {
      if (this.isSelectedAllItems) {
        this.emitInput([]);
      } else {
        this.emitInput(this.items.map((item) => item[this.itemValue]));
      }
    },
    /**
     * @description Поднять значение
     */
    emitInput(value) {
      if (this.clearOnSelect) {
        this.$nextTick(() => {
          this.searchInput = '';
        });
      }
      this.$emit('input', value);
    },
  },
  props: {
    disabled: {
      default: () => false,
      type: Boolean,
    },
    itemText: {
      default: () => 'title',
      type: String,
    },
    itemValue: {
      default: () => 'value',
      type: String,
    },
    items: {
      required: true,
      type: Array,
    },
    label: {
      default: () => '',
      type: String,
    },
    /**
     * @description Включить выборочное удаление по чипу.
     */
    removalPerChip: {
      default: () => false,
      type: Boolean,
    },
    selectAllText: {
      default: () => 'Выбрать все',
      type: String,
    },
    selectAllValue: {
      default: () => false,
      type: Boolean,
    },
    setSelectAllOption: {
      default: () => false,
      type: Boolean,
    },
    value: {
      required: true,
      type: Array,
    },
    clearOnSelect: {
      default: () => false,
      type: Boolean,
    },
  },
};
</script>

<style>
  .no-data {
    padding: 10px;
    margin: 0;
  }
  .multiline::v-deep .v-list-item__title {
    white-space: normal !important;
  }
</style>
